import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/subHours/index.js';

var require$$13 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$13 as default };
